import { cloneDeep } from 'lodash';

import type { FileInfo } from '@/services/types/file.types';

export const insertOrUpdate = <T>(array: T[], item: T, key: keyof T) => {
  const index = array.findIndex((i) => i[key] === item[key]);
  if (index !== -1) {
    array[index] = item;
  } else {
    array.push(item);
  }
};

type TransportPayloadOptions<T> = {
  normalize?: Array<(payload: T) => void>;
  stripKeys?: string[];
};

export const normalizeEmptyImageAltText = (file: FileInfo | null | undefined) => {
  const altText = file?.metadata?.image?.altText;

  // Match the actual transport shape: JSON serialization removes undefined values.
  const serializedAltText = altText ? JSON.parse(JSON.stringify(altText)) : altText;

  if (
    serializedAltText &&
    typeof serializedAltText === 'object' &&
    Object.keys(serializedAltText).length === 0 &&
    file?.metadata?.image
  ) {
    file.metadata.image.altText = null;
  }
};

export const buildTransportPayload = <T extends object>(value: T, options: TransportPayloadOptions<T> = {}): T => {
  const payload = cloneDeep(value);

  for (const key of options.stripKeys ?? []) {
    delete (payload as Record<string, unknown>)[key];
  }

  for (const normalizer of options.normalize ?? []) {
    normalizer(payload);
  }

  return payload;
};
